import {
    FETCH_SETTING_DATA_REQUEST,
    FETCH_SETTING_DATA_SUCCESS,
    FETCH_SETTING_DATA_FAILURE
} from "../types";

const initialState = {
    settingData: [],
    tourData: null,
    isLoading: false,
    error: null,
    status: "idle",
};

const settingReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SETTING_DATA_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
                status: "pending"
            };
        case FETCH_SETTING_DATA_SUCCESS:
            return {
                ...state,
                settingData: action.payload?.setting,
                tourData: action.payload?.tour_data,
                isLoading: false,
                status: "success"
            };
        case FETCH_SETTING_DATA_FAILURE:
            return {
                ...state,
                settingData: [],
                tourData: null,
                error: action.payload,
                isLoading: false,
                status: "failed"
            };
        default:
            return state;
    }
};

export default settingReducer;
